'use client'

import { useEffect } from "react"
import { getLocal, setLocal, removeLocal } from "@/utils/localStorage"
import { georgiaParts } from "@/lib/georgiaTime"

// Map a stored timestamp to its day in the form SearchBar produces
// (Date.UTC(y, m, d) / 1000). Hour-bearing stamps from the booking page are
// converted to their calendar day in Georgia (the clock they were picked on).
function toDayTs(ts) {
    if (ts % 86400 === 0) return ts;
    const p = georgiaParts(ts);
    return Math.floor(Date.UTC(p.year, p.month, p.day) / 1000);
}

function normaliseDates(dates) {
    const [start, end] = String(dates || "")
        .split(/[+ ]+/)
        .filter(Boolean)
        .map((n) => Number(n));
    if (!Number.isFinite(start) || !Number.isFinite(end) || start <= 0 || end <= 0) return null;
    const s = toDayTs(start);
    const e = toDayTs(end);
    const now = new Date();
    const today = Math.floor(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 1000);
    if (e <= s || s < today) return null;
    return `${s} ${e}`;
}

export default function LocalStorageResetter() {
    useEffect(() => {
        try {
            // Keep only the search itself (points, currency, dates) so the
            // hero can restore it; clear all booking state.
            let rec = {};
            try {
                rec = JSON.parse(getLocal("recordings") || "{}") || {};
            } catch {}
            const kept = {};
            if (rec.points) kept.points = rec.points;
            if (rec.currency) kept.currency = rec.currency;
            const dates = normaliseDates(rec.dates);
            if (dates) kept.dates = dates;
            if (Object.keys(kept).length) {
                setLocal("recordings", JSON.stringify(kept));
            } else {
                removeLocal("recordings");
            }
        } catch (e) {
            console.log(e);
          }
    }, [])
}
